// import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import { useEffect } from 'react';
import Country from './components/Country/Country';
import Cart from './components/cart/Cart';

function App() {
  const[countrys,setCountrys] = useState([]);
  const[cart,setCart] = useState([])

  useEffect(()=>{
    fetch('https://restcountries.com/v2/all')
    .then(res=>res.json())
    .then(data=> {
      setCountrys(data);})
    .catch(error=>console.log(error))

  }, []);
  const handleCountryAdded = (country) =>{
      const newCart = [...cart,country];
      setCart(newCart);

  }


  return (
    <div className="App">
      <h1>Country loded : {countrys.length}</h1>
      <h4>Country add : {cart.length}</h4>
      <Cart cart={cart}></Cart>
      <ul>
        {
          countrys.map(country => <Country country={country} handleCountryAdded={handleCountryAdded} key={country.alpha3Code}></Country>)
        } 


      </ul>
      
    </div>
  );
}

export default App;
